import { get } from "services/actions";
import strapiImg from "utils/strapiImg";
import AppLayout from "components/AppLayout";
import InstitutoRealizarPage from "components/pages/InstitutoRealizar";

export default function InstitutoRealizar({
  appLayout,
  institutoRealizarPage,
}) {
  return (
    <>
      <AppLayout data={appLayout}>
        <InstitutoRealizarPage data={institutoRealizarPage} />
      </AppLayout>
    </>
  );
}

export async function getStaticProps() {
  const header = await get("cabecalho");
  const footer = await get("rodape");
  const data = await get("instituto-realizar");
  const receiveNews = await get("receba-novidades");

  const appLayout = {
    header: {
      logo: strapiImg(header.logo, "", true),
      menu: header.menu,
    },
    footer: {
      logo: strapiImg(footer.logo, "", true),
      redes: footer.redes_sociais.map(({ id, nome, link, icone }) => {
        icone = strapiImg(icone, "", true);
        return {
          id,
          nome,
          link,
          icone,
        };
      }),
      unidades: footer.unidades,
      submenus: footer.submenu,
      whatsappIcon: strapiImg(footer?.icone_whatsapp_rodape, "", true),
      openChatBot: footer?.habilitar_chatbot
    },
  };

  const institutoRealizarPage = {
    seo: {
      titulo: data.SEO.title,
      descricao: data.SEO.description,
      imagem: strapiImg(data.SEO.image, "", true),
    },
    banner: {
      titulo: data.titulo,
      chamada: data.banner_topo.titulo,
      imagem: strapiImg(data.banner_topo.banner, "", true),
    },
    oque: {
      titulo: data.secao01.titulo,
      texto: data.secao01.texto,
      imagem: strapiImg(data.secao01.imagem, "", true),
    },
    acreditamos: {
      titulo: data.secao02.titulo,
      texto: data.secao02.texto,
      imagem: strapiImg(data.secao02.imagem, "", true),
    },
    secaoRecebaNovidades: {
      imagem: strapiImg(receiveNews.background_imagem, "", true),
      email: receiveNews.email_de_envio,
    },
  };

  return {
    props: {
      appLayout,
      institutoRealizarPage,
    },
    revalidate: 60,
  };
}
